import React, {Component, ReactNode} from 'react'
import {Box, DialogContent, Divider} from '@mui/material'
import {AdminPageHeadingArea} from '../shared/pageBaseComponents/AdminPageHeadingArea'
import {AdminPrimaryButton} from '../../styledComponents/adminPage/Buttons'
import styled from 'styled-components'
import SendIcon from '@mui/icons-material/Send'
import {BackLink} from '../../styledComponents/adminPage/Links'
import {StyledPre} from '../../styledComponents/adminPage/StyledPre'
import {NotifyDialogActions, NotifyDialogTitle} from './AssocDirectorCommon'

interface Props {
    dialogTitle: string
    dialogBody: string
    notifyTitle: string
    notifyBody: string
    notifyButtonLabel: string
    onNotify: () => void
    onClose: () => void
    onBack?: () => void
}

export class AdminMeetingNotifyDialog extends Component<Props> {
    render(): ReactNode {
        const {
            dialogTitle,
            dialogBody,
            notifyTitle,
            notifyBody,
            notifyButtonLabel,
            onNotify,
            onClose,
            onBack,
        } = this.props
        return <Box width={'750px'}>
            <NotifyDialogTitle>
                <AdminPageHeadingArea title={dialogTitle} onClose={onClose}/>
            </NotifyDialogTitle>
            <DialogContent>
                <Box>
                    <StyledPre>{dialogBody}</StyledPre>
                    <NotifyBox mt={'16px'}>
                        <NotifyTitle>
                            {notifyTitle}
                        </NotifyTitle>
                        <Divider/>
                        <NotifyBody>
                            <StyledPre>
                                {notifyBody}
                            </StyledPre>
                        </NotifyBody>
                    </NotifyBox>
                </Box>
            </DialogContent>
            <NotifyDialogActions>
                {
                    onBack ?
                        <BackLink onClick={onBack}>
                            設定に戻る
                        </BackLink>
                        :
                        <BackLink onClick={onClose}>
                            キャンセル
                        </BackLink>
                }
                <Box width={'50px'}/>
                <AdminPrimaryButton onClick={onNotify}>
                    <SendIcon/><Box ml={'15px'}>{notifyButtonLabel}</Box>
                </AdminPrimaryButton>
            </NotifyDialogActions>
        </Box>
    }
}

const NotifyBox = styled(Box)`
  border: 1px solid #D9D9D9;
`

const NotifyTitle = styled(Box)`
  padding: 15px;
  line-height: 24px;
`

const NotifyBody = styled(Box)`
  padding: 11px;
  max-height: 380px;
  overflow: scroll;
`
